import { Outlet } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";
import { ReminderScheduler } from "@/components/ReminderScheduler";

export function AppLayout() {
  return (
    <div className="min-h-[100dvh]">
      <ReminderScheduler />
      <div className="max-w-md md:max-w-4xl mx-auto min-h-[100dvh] px-4 sm:px-6 pt-6 pb-[calc(7rem+env(safe-area-inset-bottom))]">
        <Outlet />
      </div>
      <BottomNav />
    </div>
  );
}
